import styled from "styled-components";
import { COLORS } from "../../../../styles/constants.style";

export const TaxDetailsTableHeaderWrapper = styled.div`
  .dashed-line {
    margin: 24px 0px;
    border: 1px dashed ${COLORS.primary_light_blue4};
  }
`;
